export const formatUtcDate = (dateString: string, options?: Intl.DateTimeFormatOptions): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  const hasTimeOptions =
    options && (options.hour !== undefined || options.minute !== undefined || options.second !== undefined);

  if (hasTimeOptions) {
    return date.toLocaleString(undefined, { ...options, timeZone: "UTC" });
  }

  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const offsetDate = new Date(date.getTime() + userTimezoneOffset);
  return offsetDate.toLocaleDateString(undefined, options);
};

export const toUtcDateString = (date: Date): string => {
  return date.toISOString().split("T")[0];
};
